import {
  LoadBoardPosting,
  useGetActivePostingsQuery,
} from '@shared/generated/graphql';

type UseGetActivePostingsOptions = {
  id: string;
  pollInterval?: number;
};

type UseGetActivePostingsState = {
  postings: LoadBoardPosting[];
  isLoading: boolean;
};

const useGetActivePostings = (
  props: UseGetActivePostingsOptions
): UseGetActivePostingsState => {
  const { id, pollInterval } = props;
  const { data, loading } = useGetActivePostingsQuery({
    variables: { id },
    pollInterval,
  });

  return {
    postings: data?.getActivePostings?.postings ?? [],
    isLoading: loading,
  };
};

export default useGetActivePostings;
